<template lang="pug">
#bloco-inserir-dados-contrato-originacao-manual
    CardBuscaTerritorios(
        ref='cardBuscarTerritorios',
        :dados='dados',
        :numeroContrato='numeroContrato',
        :isRastreabilidadeOffline='isRastreabilidadeOffline',
        :volumeDisponivelContrato='volumeDisponivelContrato',
        :idSucursal='idSucursal',
        @emitir-elegibilidade='handleAnaliseElegibilidade',
        @modal-territorios='handleMostrarModalTerritorios',
        @territorio-inserido='handleTerritorioInserido',
        @mostrar-modal-capacidade='handleMostrarModalCapacidade'
    )

    ModalCadastrarTerritorioManual(
        :mostrar='showModalCadastroTerritorio',
        @fechar='showModalCadastroTerritorio = false',
        @territorio-cadastrado='definirVolumeTerritorioCadastrado'
    )

    ModalAnaliseElegibilidadeResumoAr(
        :show='ativarModalAnaliseElegibilidade',
        :dados='dadosAnaliseElegibilidade',
        @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false'
    )

    .modal-definir-volume(v-if='showModalDadosCadastroManual')
        ModalDadosCadastroManual(
            :mostrar='showModalDadosCadastroManual',
            @fechar='showModalDadosCadastroManual = false',
            :territorio='territorioCadastrado',
            @definir-volume='definirVolume'
        )

    .modal-selecionar-territorios-py
        ModalSelecionarTerritoriosAr(
            :show='mostrarModalDadosTerritorioAr',
            :dados='dadosTerritorioAr',
            :tipo-contrato='materialSelecionado',
            @voltar='mostrarModalDadosTerritorioAr = false',
            @retornarDadosSelecionados='exibirDadosTerritorioSelecionado'
        )

    .modal-media-capacidade-produtiva(v-if='showModalDadosCapacidadeProdutiva')
        el-dialog(
            :visible.sync='showModalDadosCapacidadeProdutiva',
            :close-on-click-modal='false'
        )
            template(slot='title')
                .modal-media-capacidade-produtiva__title
                    i.el-icon-error
                    span {{ dadosMediaCapacidadeProdutivaRegional.title }}

            p {{ dadosMediaCapacidadeProdutivaRegional.message }}

            .modal-media-capacidade-produtiva__linha
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.territorio') }}
                    p {{ dadosMediaCapacidadeProdutivaRegional.territorioNome }}
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.area') }}
                    p {{ dadosMediaCapacidadeProdutivaRegional.territorioArea }}
            .modal-media-capacidade-produtiva__linha
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volumeMax') }}
                    p.modal-media-capacidade-produtiva__permitido {{ dadosMediaCapacidadeProdutivaRegional.volumeMaximoPermitido }}
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.volumeAdc') }}
                    p.modal-media-capacidade-produtiva__excedente {{ volumeAtual + ' t' }}

            hr

            el-table(
                :data='dadosMediaCapacidadeProdutivaRegional.medias',
                style='width: 100%'
            )
                el-table-column(
                    prop='estadoNome',
                    label='Estado',
                    align='center',
                    width='100'
                )
                el-table-column(prop='mediaRegionalPorUnidade', align='center')
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.fonte") + dadosMediaCapacidadeProdutivaRegional.fonte',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.mediaRegional') }}
                el-table-column(
                    prop='mediaPermitidaPorUnidade',
                    label='Média permitida',
                    align='center'
                )
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='dadosMediaCapacidadeProdutivaRegional.mediaPermitidaPorUnidadeTooltip',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.maxPermitido') }}
                el-table-column(
                    prop='mediaTerritorioPorUnidade',
                    align='center'
                )
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='dadosMediaCapacidadeProdutivaRegional.mediaTerritorioPorUnidadeTooltip',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.mediaVolumeInserido') }}
                el-table-column(align='center')
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='dadosMediaCapacidadeProdutivaRegional.excedentePorUnidadeTooltip',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.ExcedenteMaximo') }}
                    template(slot-scope='scope')
                        div
                            span.modal-media-capacidade-produtiva__excedente {{ scope.row.excedentePorUnidade }}
            span.dialog-footer(slot='footer')
                el-button(
                    type='primary',
                    @click='showModalDadosCapacidadeProdutiva = false'
                ) Ok
</template>

<script>
import CardBuscaTerritorios from './SubEmpresaCardBuscaTerritoriosAR.vue';
import ModalDadosCadastroManual from '@/components/contratosOriginacao/SubEmpresaModalRevisarTerritorio.vue';
import ModalCadastrarTerritorioManual from '@/components/contratosOriginacao/SubEmpresaModalCadastrarTerritorio.vue';
import ModalSelecionarTerritoriosAr from '@/components/contratosOriginacao/ModalSelecionarTerritoriosAr.vue';
import ModalAnaliseElegibilidadeResumoAr from '@/components/contratosOriginacao/ModalAnaliseElegibilidadeResumoAr.vue';

export default {
    name: 'SubEmpresaGestaoElegibilidadeAR',
    components: {
        CardBuscaTerritorios,
        ModalCadastrarTerritorioManual,
        ModalDadosCadastroManual,
        ModalAnaliseElegibilidadeResumoAr,
        ModalSelecionarTerritoriosAr
    },

    props: {
        volumeDisponivelContrato: {
            type: Number,
            required: true
        },
        dados: {
            type: Object,
            required: true
        },
        isRastreabilidadeOffline: {
            type: Boolean,
            required: true
        },
        dadosEdicaoVolume: {
            type: Object,
            default: null
        }
    },

    watch: {
        dadosEdicaoVolume(newVal) {
            if (newVal) {
                this.$refs.cardBuscarTerritorios.preencherParaEdicao(newVal);
                if (this.$route.query.autoAnalise === 'true' && !this._autoAnaliseDisparada) {
                    this._autoAnaliseDisparada = true;
                    this.$nextTick(() => {
                        this.$refs.cardBuscarTerritorios.validarTerritorioResumo();
                    });
                }
            }
        }
    },

    data() {
        return {
            numeroContrato: this.$route.params.numeroContrato,
            idSucursal: this.$route.params.idSucursal || this.$route.query.idSucursal || 0,
            showModalCadastroTerritorio: false,
            showModalDadosCadastroManual: false,
            showModalDadosCapacidadeProdutiva: false,
            territorios: [],
            territorioCadastrado: {},
            dadosAnaliseElegibilidade: {
                elegibilidade: '',
                valor: '',
                cpfCnpj: '',
                safraNome: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                saldoTerritorial: {
                    areaHa: null,
                    anoSafra: null,
                    capacidadeProdutiva: null,
                    cultura: null,
                    rendimento: null,
                    renspa: null,
                    saldoCapacidadeProdutiva: null,
                    saldoConsumidoCapacidadeProdutiva: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null,
                    siglaEstadoContrato: null
                },
                dadosRestricaoEstado: {
                    possuiRestricaoEstado: null,
                    siglaEstadoCar: null,
                    siglaEstadoPermitido: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                },
                territorioOutput: {
                    finca: null,
                    padron: null,
                    geom: null,
                    idTerritorio: null,
                    nomeTerritorio: null
                }
            },
            ativarModalAnaliseElegibilidade: false,
            mostrarModalDadosTerritorioAr: false,
            dadosTerritorioAr: [],
            dadosMediaCapacidadeProdutivaRegional: {
                medias: []
            },
            volumeAtual: '',
            materialSelecionadov: null
        };
    },

    methods: {
        handleAnaliseElegibilidade(dados) {
            this.dadosAnaliseElegibilidade = dados;
            this.ativarModalAnaliseElegibilidade = true;
        },

        handleTerritorioInserido() {
            this.$emit('atualizarListaPosInserir');
        },

        definirVolumeTerritorioCadastrado(territorioCadastrado) {
            this.showModalCadastroTerritorio = false;
            this.territorioCadastrado = territorioCadastrado;
            setTimeout(() => (this.showModalDadosCadastroManual = true), 500);
        },

        definirVolume(volume) {
            this.volumeAtual = volume;
            this.showModalDadosCadastroManual = false;
        },

        handleMostrarModalTerritorios(dadosTerritorios, materialSelecionado) {
            this.dadosTerritorioAr = dadosTerritorios;
            this.materialSelecionado = materialSelecionado;
            this.mostrarModalDadosTerritorioAr = true;
        },

        handleMostrarModalCapacidade(dadosCapacidade) {
            const {
                estadoNome,
                mediaRegionalPorUnidade,
                mediaPermitidaPorUnidade,
                mediaTerritorioPorUnidade,
                excedentePorUnidade,
                percentualExcedentePorUnidade
            } = dadosCapacidade;

            const medias = [
                {
                    estadoNome,
                    mediaRegionalPorUnidade,
                    mediaPermitidaPorUnidade,
                    mediaTerritorioPorUnidade,
                    excedentePorUnidade,
                    percentualExcedentePorUnidade
                }
            ];

            this.dadosMediaCapacidadeProdutivaRegional = {
                title: dadosCapacidade.title,
                message: dadosCapacidade.message,
                medias,
                ...dadosCapacidade
            };

            this.showModalDadosCapacidadeProdutiva = true;
        },

        resetarFormularios() {
            this.$refs.cardBuscarTerritorios.resetFormularioCompleto();
        },

        exibirDadosTerritorioSelecionado(territorio) {
            this.mostrarModalDadosTerritorioAr = false;

            if (territorio) {
                this.$refs.cardBuscarTerritorios.definirTerritorioSelecionado(
                    territorio
                );
            }
        }
    }
};
</script>

<style lang="scss">
#bloco-inserir-dados-contrato-originacao-manual {
    width: 100%;

    .modal-media-capacidade-produtiva {
        .modal-media-capacidade-produtiva__title {
            .el-icon-error {
                margin-right: 5px;
                color: var(--danger);
                font-size: 24px;
            }
        }

        .modal-media-capacidade-produtiva__info {
            margin-right: 5px;
            color: var(--secondary-font-color);
        }

        .modal-media-capacidade-produtiva__label {
            font-weight: bold;
            margin-right: 5px;
            color: var(--primary);
        }

        .modal-media-capacidade-produtiva__excedente {
            color: var(--danger);
            font-weight: bold;
        }

        .modal-media-capacidade-produtiva__permitido {
            color: var(--success);
            font-weight: bold;
        }

        .el-dialog__header {
            display: flex;
            align-items: flex-end;

            span {
                font-size: 18px;
            }
        }

        .el-dialog__body {
            font-size: 14px;
            padding: 20px 20px;
        }

        .modal-media-capacidade-produtiva__linha {
            display: flex;
            justify-content: space-between;
            gap: 30px;
        }

        .modal-media-capacidade-produtiva__coluna {
            width: 100%;
        }
    }
}
</style>
